import { Accordion } from '../modules/accordion';

const sections = document.querySelectorAll('section.schedule');

if (sections.length > 0) {
    sections.forEach(section => {
        const accordion = new Accordion({
            el: section,
            collapse: true,
            firstExpanded: true,
        });

        const loadMoreButton = section.querySelector(
            '.schedule__load-more-button'
        );
        const accordionItems = section.querySelectorAll('.accordion__item');

        if (loadMoreButton && accordionItems.length > 0) {
            loadMoreButton.addEventListener('click', () => {
                accordionItems.forEach(item => item.classList.remove('d-none'));
                loadMoreButton.classList.add('d-none');
            });
        }
    });
}
